import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { getConsumerDocumentTitle } from "./document-title.helpers";

export function ConsumerDocumentTitle() {
  const { pathname, search } = useLocation();
  const title = getConsumerDocumentTitle(pathname, search);

  useLayoutEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
